// import { FilterType } from '@shopify/polaris';

export const resourceName = { singular: 'bundle', plural: 'bundles' };

export const filters = [];
